import axios from "axios";

const instance = axios.create({
  baseURL: "https://impactfund.tipstatweb.com/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use((config) => {
  config.headers.Authorization = localStorage.token;
  return config;
});

export default instance;
